import { TechnicalStatuses } from "../../constants/technical_statuses";

export default {
  name: "DashboardFilters",
  props: {
    selectedFilter: Object,
    setFilter: Function,
    options: Array,
    mainOptions: Array,
    count: Object
  },
  data() {
    return {};
  },
  methods: {
    handleOnClickFilter(filter) {
      this.setFilter(filter);
    },
  },
  mounted(){
    if(this.options[0].filter === TechnicalStatuses.GatewayStatus){
      this.setFilter(this.options[0])
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_dashboard-filters/dashboard-filters.js